import { AppState } from "store";
import { DataSetsFiltersArgs } from "./types";

export const dataSetsFiltersSelector = ({
  filters,
}: AppState): DataSetsFiltersArgs => {
  return filters.dataSets;
};
